import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportExcelRecentEventListMutationVariables = Types.Exact<{
  input: Types.ExportExcelRecentEventListInput;
}>;

export type ExportExcelRecentEventListMutation = {
  __typename?: 'Mutation';
  exportExcelRecentEventList: {
    __typename?: 'ExportExcelRecentEventListResponse';
    message: string;
    success: boolean;
    fileKey: string;
    status: string;
    fileName: string;
  };
};

export const ExportExcelRecentEventListDocument = gql`
  mutation ExportExcelRecentEventList(
    $input: ExportExcelRecentEventListInput!
  ) {
    exportExcelRecentEventList(input: $input) {
      message
      success
      fileKey
      status
      fileName
    }
  }
`;
export type ExportExcelRecentEventListMutationFn = Apollo.MutationFunction<
  ExportExcelRecentEventListMutation,
  ExportExcelRecentEventListMutationVariables
>;
export function useExportExcelRecentEventListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportExcelRecentEventListMutation,
    ExportExcelRecentEventListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportExcelRecentEventListMutation,
    ExportExcelRecentEventListMutationVariables
  >(ExportExcelRecentEventListDocument, options);
}
export type ExportExcelRecentEventListMutationHookResult = ReturnType<
  typeof useExportExcelRecentEventListMutation
>;
export type ExportExcelRecentEventListMutationResult =
  Apollo.MutationResult<ExportExcelRecentEventListMutation>;
export type ExportExcelRecentEventListMutationOptions =
  Apollo.BaseMutationOptions<
    ExportExcelRecentEventListMutation,
    ExportExcelRecentEventListMutationVariables
  >;
